import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AnalyticsModule } from '@flyfreely-portal-ui/analytics';
import { SharedUiModule } from '@flyfreely-portal-ui/ui';
import {
    RegisteredWidgets,
    WidgetManager,
    WidgetModule,
    WidgetRegistration
} from '@flyfreely-portal-ui/widget';
import { DashboardComponent } from './dashboard.component';
import { ManageDashboardWidgetsService } from './manage-dashboard-widgets.service';
import { WidgetSelectionComponent } from './widget-selection/widget-selection.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule.forChild([]),
        WidgetModule,
        SharedUiModule,
        AnalyticsModule
    ],
    declarations: [DashboardComponent, WidgetSelectionComponent],
    providers: [ManageDashboardWidgetsService]
})
export class ManageDashboardModule {
    static forRoot(
        registeredWidgets: WidgetRegistration[]
    ): ModuleWithProviders<any> {
        return {
            ngModule: ManageDashboardModule,
            providers: [
                // FIXME figure out how to properly inject tokens
                {
                    provide: RegisteredWidgets,
                    useValue: new RegisteredWidgets(registeredWidgets)
                },
                {
                    provide: WidgetManager,
                    useExisting: ManageDashboardWidgetsService
                }
            ]
        };
    }
}
